import React, { useState } from "react";
import Message from "../../../../pages/components/message";
import { MessageSections } from "../../../../pages/components/message/message";
import { ActionDialogContent } from "./shared/styled";
import { OrderModel } from "../../../../pages/shared/models/order/order-item.model";
import BarekamInput from "../../../../pages/components/input";
import { StandardDialogFooter } from "../../../../pages/components/dialogs/standard-dialog/standard-dialog";
import ordersService from "../../../../services/orders.service";
import { useAppSelector } from "../../../../redux/store";
import { AxiosError } from "axios";
import { mapValidationErrors } from "../../../../pages/user/settings/personal-info/personal-info.service";
import { getMessage } from "../../../../pages/shared/helper-functions";

export const Discount = ({ order, onClose }: DiscountProps) => {
  const [discount, setDiscount] = useState(order.discount || null);
  const [discountReason, setDiscountReason] = useState(
    order.discountReason || "",
  );
  const [errors, setErrors] = useState<{ [key: string]: string }>({});

  const { messageCache, languageId } = useAppSelector(
    (state) => state.messagesReducer,
  );

  function handleDiscountChange(amount: number) {
    const price = order?.paymentInfo?.shippingAmount || 0;
    setDiscount(amount > 0 && price >= amount ? +amount : null);
  }

  function doAction() {
    if (order.orderId) {
      ordersService
        .updateById({ discount, discountReason }, order.orderId, languageId)
        .then((response) => {
          onClose();
        })
        .catch((reason) => {
          if (reason instanceof AxiosError) {
            setErrors(mapValidationErrors(reason));
          }
        });
    }
  }

  return (
    <>
      <ActionDialogContent>
        <BarekamInput
          value={discount || ""}
          placeholder={getMessage(
            "discount_amount_in_amd",
            MessageSections.MAIN,
            messageCache,
            languageId,
          )}
          type={"number"}
          customInputVariant={"standard"}
          width={"100%"}
          error={!!errors.discount}
          errorMessage={
            errors.discount &&
            getMessage(
              errors.discount,
              MessageSections.ORDERS,
              messageCache,
              languageId,
            )
          }
          onChange={(event) => handleDiscountChange(+event.target.value)}
        />

        <BarekamInput
          value={discountReason || ""}
          placeholder={getMessage(
            "discount_reason",
            MessageSections.ORDERS,
            messageCache,
            languageId,
          )}
          label={getMessage(
            "discount_reason",
            MessageSections.ORDERS,
            messageCache,
            languageId,
          )}
          type={"string"}
          customInputVariant={"standard"}
          width={"100%"}
          onChange={(event) => setDiscountReason(event.target.value)}
          error={!!errors.discountReason}
          errorMessage={
            errors.discountReason &&
            getMessage(
              errors.discountReason,
              MessageSections.ORDERS,
              messageCache,
              languageId,
            )
          }
          required
        />
      </ActionDialogContent>

      <StandardDialogFooter
        saveLabel={
          <Message
            messageKey={"set_discount"}
            sectionId={MessageSections.ORDERS}
          />
        }
        onSave={() => doAction()}
        onCancel={() => onClose()}
      />
    </>
  );
};

interface DiscountProps {
  order: OrderModel;
  onClose: () => void;
}
